// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__1Qjgw","label":"Switch_label__rbBHg","input":"Switch_input__vnRVm","track":"Switch_track__yw3KR","thumb":"Switch_thumb__CpXFi"};